export enum RevenueOptionsType {
  'revenue' = 'revenue',
  'revenueMW' = 'revenueMW'
}